<template>
    <section class="main-content pb-5">
        <div class="container-fluid">

<div class="ibox float-e-margins">
    <div class="ibox-title">
        <h5 style="font-family: 'Kanit', sans-serif; font-size: 16px;"><b>วิธีการใช้งาน</b></h5>
    </div>
    <div class="ibox-content">
        <div class="form-group has-feedback" style="font-size: 14px;">

            <p style="margin: 0cm 0cm 7.5pt;"><b></b></p>
            <p style="margin: 0cm 0cm 7.5pt;">{{site_name}} มีความยินดีดูแลสมาชิกทุกยูสเซอร์ด้วยความจริงใจ ซื่อสัตย์ มั่นคง จริงใจ หากท่านมีปัญหาหรือต้องการคำแนะนำ สามารถติดต่อได้ตลอด  24 ชั่วโมง</p>

            <p style="margin: 0cm 0cm 7.5pt;"><b></b></p>
            <p style="margin: 0cm 0cm 7.5pt;">เปิดแจ้งฝาก-เครดิตได้ตลอด 24 ชั่วโมง</p>
            <p style="margin: 0cm 0cm 7.5pt;">สมาชิกแจ้ง-ถอน ในเวลา 08.00-23.00 น ตามลำดับ เวลา user ที่แจ้งเข้ามา</p>
            <p style="margin: 0cm 0cm 7.5pt;">การฝากเงินขั้นต่ำ {{ deposit_amount_limit }} บาท** ขึ้นไป</p>
            <p style="margin: 0cm 0cm 7.5pt;">แจ้งถอนขั้นต่ำ {{ withdraw_amount_limit }} บาท** ขึ้นไป</p>
                                                
            <p style="margin: 0cm 0cm 7.5pt;"><br></p>

            <p style="margin: 0cm 0cm 7.5pt;">
                <span lang="TH"><b>ติดต่อ Call Center</b></span>
                <br>
                <span lang="TH"><b>LINE ID : <a :href="line_contact" target="_blank">{{line_name}}</a> </b></span>
                <br>
                <br>
                <span lang="TH"><b>** ด้วยความห่วงใย และ ปรารถนาดี จาก ทีมงาน {{site_name}} **</b></span>
            </p>


        </div>

    </div> <!-- /.ibox-content -->
</div>





        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'helpcenter',
    data () {
        return {
            site_name: '',
            line_contact: '',
            line_name: '',
            bank_data: {},
            deposit_amount_limit: 1,
            withdraw_amount_limit: 1,
        }
    },
    methods: {
        async loadLineContact () {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
                this.line_name = response.name

            } catch (error) {
                console.log('error', error)
            }
        },
        async loadWithdrawData () {
            try {

                const responseWithdraw = await this.$store.dispatch('jobtask/getTotalWithdraw',this.user.id)
                //console.log('processWithdraw responseWithdraw', responseWithdraw)

                this.withdraw_amount_limit = responseWithdraw.DEFAULT_LIMIT

            } catch (error) {
                let error_msg = 'There was an error connecting to the server.'
                let response = error.response.data
                if ( response ) {
                    error_msg = 'ยังไม่เปิดให้แจ้งถอนเครดิต, ทางระบบยังไม่พร้อมให้บริการ ' + response.message
                }
                this.$toasted.error(error_msg)
                this.$router.push({name: 'home',})
            }
        },
        async getActiveBankData (bank_id) {
            try {
                this.bank_data = {}

                const response = await this.$store.dispatch('jobtask/getActiveBankData', bank_id)
                //console.log('getActiveBankData: ', response)

                if ( response ) {

                    this.bank_data = response

                    let logo = (this.bank_data.bank_code).toLowerCase() + '.png'
                    this.bank_data.logo = require('@/assets/images/banks/'+ logo)

                    if (this.bank_data.deposit_limit) {
                        this.deposit_amount_limit = this.bank_data.deposit_limit
                    }

                    // this.loadUserData()
                }

            } catch (error) {
                let error_msg = 'Hmm, something you entered doesn\'t seem right.'
                let response = error.response.data
                if ( response ) {
                    error_msg = 'ยังไม่เปิดให้แจ้งเติมเครดิต, ทางระบบยังไม่พร้อมให้บริการ ' + response.message
                }

                this.$toasted.error(error_msg)
                this.$router.push({name: 'home',})
            }
        },
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            lineContact: state => state.information.lineContact,
        }),
        lastUpdate () {
            let now = new Date()
            return moment(now).format('DD/MM/YYYY HH:mm:ss')
        },
    },
    created () {
        this.site_name = process.env.VUE_APP_SITE

        if (this.lineContact.link || this.lineContact.name){
            this.line_contact = this.lineContact.link
            this.line_name = this.lineContact.name
        }
        else {
            this.loadLineContact()
        }
        this.getActiveBankData()
        this.loadWithdrawData()

    },
    destroyed () {
    }
}

</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';

    .note-block {
        &__note {
            background: lighten($light-grey, 2%);
            padding: 10px;
            border-radius: 6px;
            margin-bottom: 20px;
            border: 1px solid $grey;

            &:hover {
                cursor: pointer;
                opacity: 0.8;
            }
        }
    }

</style>
